import React from "react";
import { IconProps } from "./type";
import "../../styles/icon.scss";

const Icon = ({
  name,
  onClick,
  customClassName = "",
  style,
  size = "normal",
  fill = true,
}: IconProps) => {
  const className = onClick
    ? `icon-container normal-button icon-container-${size}`
    : `icon-container icon-container-${size}`;
  return (
    <div
      className={`${className} ${fill ? "icon-container__icon-fill" : ""}`}
      onClick={onClick}
      style={style}
    >
      <i
        className={`material-icons icon-container__icon-${size} ${customClassName}`}
      >
        {name}
      </i>
    </div>
  );
};

export default Icon;
